import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

interface TableOfContentStylesProps {
  hideOnDesktop?: boolean;
}

export const TableOfContentStyles = styled.div<TableOfContentStylesProps>`
  ${({ hideOnDesktop }) =>
    !hideOnDesktop
      ? ''
      : css`
          display: none;

          @media screen and (max-width: ${layout.md}) {
            display: block;
          }
        `}
`;
export const InThisArticleParagraph = styled.p<TableOfContentStylesProps>`
  ${({ hideOnDesktop }) =>
    !hideOnDesktop
      ? ''
      : css`
          display: none;

          @media screen and (max-width: ${layout.md}) {
            display: block;
          }
        `}
`;
